import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import {
  AllTooltipModel,
  SystemInstTopTermResults,
  UnitTopTermResults,
} from '../../models';

@Injectable({ providedIn: 'root' })
export class TrendingService {
  private http = inject(HttpClient);
  private _baseUrl = '/api/trending';
  private unitFilter = new BehaviorSubject<Set<number>>(null);

  getTrendingTermsUnit(unitAAId: number) {
    return this.http.post<UnitTopTermResults>(`${this._baseUrl}/terms/unit`, {
      unitAAId,
    });
  }

  getTrendingTermsInstitution(instId: number) {
    return this.http.post<SystemInstTopTermResults>(
      `${this._baseUrl}/terms/institution`,
      { institutionId: instId },
    );
  }

  getTrendingTermsSystem(systemId: number) {
    return this.http.post<SystemInstTopTermResults>(
      `${this._baseUrl}/terms/system`,
      { systemId: systemId },
    );
  }

  getTootipAllByUnit(unitAAId: number, termId: number, personAAIds: number[]) {
    return this.http.post<AllTooltipModel[]>(
      `${this._baseUrl}/tooltip/all/unit`,
      { unitAAId, termId: termId, filterIds: personAAIds },
    );
  }

  getTooltipAllByInstitution(
    instId: number,
    termId: number,
    broadfieldIds: number[],
  ) {
    return this.http.post<AllTooltipModel[]>(
      `${this._baseUrl}/tooltip/all/institution`,
      { institutionId: instId, termId: termId, filterIds: broadfieldIds },
    );
  }

  getTooltipAllBySystem(
    systemId: number,
    termId: number,
    broadfieldIds: number[],
  ) {
    return this.http.post<AllTooltipModel[]>(
      `${this._baseUrl}/tooltip/all/system`,
      { systemId: systemId, termId: termId, filterIds: broadfieldIds },
    );
  }

  getUnitFilterObservable() {
    return this.unitFilter.asObservable();
  }

  setUnitFilter(ids: Set<number>) {
    const currentFilter = this.unitFilter.getValue();
    if (
      !currentFilter ||
      !(
        ids.size === currentFilter.size &&
        Array.from(currentFilter).every((id) => ids.has(id))
      )
    ) {
      this.unitFilter.next(ids);
    }
  }
}
